import { z } from 'zod';

const EnvSchema = z.object({
  VITE_BACKEND_URL: z.string().url(),
  VITE_VAPI_TOKEN: z.string(),
  VITE_VAPI_KEY: z.string(),
  VITE_PLAY_API: z.string().url(),
  VITE_CLIENT_ID: z.string(),
  VITE_PYTHON_API: z.string().url(),
  VITE_SOCKET_URL: z.string().regex(/^wss?:\/\/[^\s/$.?#].[^\s]*$/, {
    message: 'Invalid WebSocket URL'
  }),
  VITE_ELEVNLABS_KEY: z.string(),
  VITE_MALLORY_VOICE: z.string(),
  VITE_STRIPE_PUBLISHABLE_KEY: z.string(),
  VITE_VAPI_PLAY: z.string().url(),
  VITE_MAX_CONVERSATION_SECONDS: z.coerce.number(),
  VITE_API_RETRY_TIMES: z.coerce.number(),
  VITE_SIMULATION_FEEDBACK_TOTAL_WORDS: z.coerce.number(),
  VITE_INTERCOM_APP_ID: z.string().optional()
});

export const config = EnvSchema.parse(import.meta.env);
